import blueGift from '../../../assets/blue_gift.png';
import pinkGift from '../../../assets/pink_gift.png';
import purpleGift from '../../../assets/purple_gift.png';
import yellowGift from '../../../assets/yellow_gift.png';

import classes from './BonusProgress.module.scss';

const images = new Map([
  [8, yellowGift],
  [15, blueGift],
  [22, pinkGift],
  [30, purpleGift],
]);

export default function ProgressBonusImage(props: { day: number; onClick?: () => void }) {
  return <img alt="gift-image" className={classes.image} src={images.get(props.day)} onClick={props.onClick} />;
}
